import axios from "../config/axios";
import { FORGET_PASSWORD_URL, LOGIN_URL } from "./api.url.service";
import { useSnackbar } from "notistack";

const Users = {
  login: function (payload) {
    return axios
      .post(LOGIN_URL, payload)
      .then((resp) => {
        return resp.data;
      })
      .catch((err) => {
        console.log("err:::", err);
        const { enqueueSnackbar } = useSnackbar();
        enqueueSnackbar(err, { variant: "error" });
      });
  },
  forgetpassword: function (payload) {
    return axios.post(FORGET_PASSWORD_URL, payload).then((response) => {
      return response.data;
    })
      .catch((err) => {
        console.log("Err", err);
        return err;
      })
  }
};

export default Users;
